import React, { useEffect, useState } from 'react'
import { getRecipesWithPage } from "../../../services/serviceRecipe";
import { Row, Table } from "antd";
import RecipeActions from "../RecipeActions";
import userDateFormatter from "../../../services/formatters/userDateFormatter";
import { SearchOutlined } from "@ant-design/icons";
import Filter from "../../filterWrapper/Filter";
import RecipeFilter from "../filter/RecipeFilter";
import { useLocation } from "@reach/router";

const Recipe = ({navigate}) => {
    const location = useLocation();
    const [sortedList, setSortedList] = useState([]);
    const [openFilter, setOpenFilter] = useState(false);
    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10,
        total: 0
    });
    const [filters, setFilters] = useState({
        createdBy: '',
        code: '',
        name: ''
    });

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const page = parseInt(queryParams.get('pn')) || 1;
        const pageSize = parseInt(queryParams.get('ps')) || 10;

        getRecipes(page, pageSize);
    }, [location.search]);

    const getRecipes = (page, pageSize, requestObj = filters) => {
        const mockFilters = { ...requestObj };
        mockFilters.pageSize = pageSize;
        mockFilters.pageNo = Number(page) - 1;
        getRecipesWithPage(mockFilters)
            .then(({ data }) => {
                sortData(data.content);
                setPagination({
                    ...pagination,
                    current: page,
                    total: data.totalElements,
                    pageSize: pageSize
                })
            })
    };

    const handlePaginationChange = (pageNumber, pageSize) => {
        navigate(`?ps=${pageSize}&pn=${pageNumber}`);
    };

    const sortData = (list) => {
        const sorted = list.map(recipe => ({
            key: recipe.id,
                id: recipe.id,
                recipeCreator: recipe.cb,
                recipeDate: userDateFormatter(recipe.cd),
                recipeCode: recipe.c,
                recipeName: recipe.n,
                imageUrl: recipe.iu,
                recipeDescription: recipe.d,
                recipeTotal: recipe.p
        }))
        setSortedList(sorted)
    }
    const toggleFilterDisplay = () => setOpenFilter(!openFilter)
    function handleFilter({ createdBy, code, name }) {
        const requestObj = {}
        Object.keys(arguments[0]).map(key => {
            requestObj[key] = arguments[0][key]
        })
        setFilters(requestObj);
        navigate(`?ps=${10}&pn=${1}&rn=${Math.floor(Math.random(1) * 1000)}`);

        return new Promise((resolve) => resolve(200))
    }
    const updater = () => {
        getRecipes(1, 10)
    }

    const columns = [
        {
            title: 'Oluşturma Tarihi',
            dataIndex: 'recipeDate',
            key: 'recipeCreator'
        },
        {
            title: 'Oluşturan',
            dataIndex: 'recipeCreator',
            key: 'recipeCreator'
        },
        {
            title: 'Reçete Kodu',
            dataIndex: 'recipeCode',
            key: 'recipeCode'
        },
        {
            title: 'Reçete Adı',
            dataIndex: 'recipeName',
            key: 'recipeName'
        },
        {
            title: 'Reçete Açıklaması',
            dataIndex: 'recipeDescription',
            key: 'recipeDescription'
        },
        {
            title: 'Görsel',
            render: (t, r) => r.imageUrl && r.imageUrl.length ? <a href={r.imageUrl} target={'_blank'} rel="noopener noreferrer">Tıklayınız</a> : '-'
        },
        {
            title: 'Reçete Tutarı',
            dataIndex: 'recipeTotal',
            key: 'recipeTotal',
            render: (text) => `${text.toFixed(2)} USD`
        },
        {
            title: 'İşlemler',
            key: 'action',
            render: (text, record) => <RecipeActions record={record} updater={updater} />
        }
    ];

    const resetFilters = () => {
        const baseObj = {
            createdBy: '',
            code: '',
            name: ''
        };
        setFilters(baseObj);
        navigate(`?ps=${10}&pn=${1}&rn=${Math.floor(Math.random(1) * 1000)}`);
    };

    return (
        <React.Fragment>
            <Row justify={"start"}>
                <div className={'filter-row-container'} onClick={toggleFilterDisplay}><SearchOutlined /></div>
            </Row>
            <Table
                scroll={{ x: 'max-content' }}
                columns={columns}
                dataSource={sortedList}
                pagination={{
                    ...pagination,
                    showSizeChanger: true,
                    showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
                    onChange: handlePaginationChange,
                }}
            />
            {
                <Filter
                    showDrawer={openFilter}
                    closer={toggleFilterDisplay}
                    relatedComponent={'Reçete'}
                    handler={handleFilter}
                    resetHandler={resetFilters}
                >
                    <RecipeFilter />
                </Filter>
            }
        </React.Fragment>
    )
}
export default Recipe